// @71153 - Cadastro de Motivos
<template>
    <div>
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("motivo") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t($route.meta.contexto)
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t("cadastros") }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t("motivo") }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="!integracao && permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: `${$route.meta.abrev}-motivo-new` })"
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-5">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                ref="origemSelect"
                                title="origem"
                                placeholder="selecione"
                                :options="origemSelect"
                                :mlLabels="true"
                                v-model="origemSelected"
                                @input="onOrigemChanged"
                                :height="40"
                                :clearable="true"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                ref="situacaoInput"
                                title="situacao"
                                :options="situacaoSelect"
                                :mlLabels="true"
                                @input="onSituacaoChanged"
                                v-model="situacaoSelected"
                                :height="40"
                                :clearable="true"
                            />
                        </div>
                    </div>
                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="motivos"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="{'excluir-field': f.key == 'excluir'}"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'motivo'">
                                    <router-link
                                        :to="{
                                            name: `${$route.meta.abrev}-motivo-edit`,
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'cor'">
                                    <div
                                        class="color-block"
                                        :style="{ 'background-color': props.row[f.key] }"
                                    ></div>
                                </div>
                                <div v-else-if="f.key == 'icone'">
                                    <span
                                        v-if="!cleanHide"
                                        v-html="buildIcon(props.row[f.key])"
                                        ref="icone"
                                        class="icon has-text-dark"
                                    >
                                    </span>
                                </div>
                                <div v-else-if="f.key == 'excluir'">
                                    <span v-if="permissao.delete&&!integracao">
                                        <b-button
                                            class="action-button"
                                            :type="
                                                props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                            "
                                            :icon-right="
                                                props.row['situacao'] == 1 ? 'delete' : 'check'
                                            "
                                            @click="promptChangeSituacao(props.row)"
                                            v-tippy 
                                            :title="$t(
                                                props.row['situacao'] == 1 ? 'desativar' : 'reativar'
                                            )"
                                        />
                                    </span>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t("ativo") }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t("inativo") }}</b-tag
                                    >
                                </div>
                                <div v-else-if="f.key == 'origem'">
                                    {{ $t(props.row[f.key]) }}
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import MotivoService from "@/services/agro/MotivoService";
import { mapState } from "vuex";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes(`${to.meta.abrev}-motivo`) 
            && to.name !=`${to.meta.abrev}-motivo-list`
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            cleanHide: false,
            integracao: this.$store.state.user.tabelasERPWebServer.includes("MOTIVO"),
            motivos: [],
            situacaoSelect: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacaoSelected: { id: 2, label: "todos" },
            service: new MotivoService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: null, sortable: false, sortFn: null },
                { key: "motivo", width: null, sortable: true, sortFn: null },
                { key: "origem", width: null, sortable: true, sortFn: null },
                { key: "cor", width: null, sortable: false, sortFn: null },
                { key: "icone", width: null, sortable: false, sortFn: null },
                { key: "situacao", width: 70, sortable: false, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "idmotivoerp",
            order: "asc",
            permissao: {},
            origemSelect: [{ id: 0, label: 'todos' }],
            origemSelected: { id: 0, label: 'todos' },
            origemLoading: false,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.rotaAninhada = (
            this.$route.name.includes(`${this.$route.meta.abrev}-motivo`) 
            && this.$route.name != `${this.$route.meta.abrev}-motivo-list`
        );

        if (this.$route.meta.contexto == "agro") {
            this.permissao = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-motivo"
            );
        } else if (this.$route.meta.contexto == "despesas") {
            this.permissao = this.hasPermissionAccess(
                "despesas",
                "cadastros",
                "des-motivo"
            );
        } else if (this.$route.meta.contexto == "vendas") {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "financeiro",
                "ven-motivo"
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivo" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        loadOrigem() {
            this.origemLoading = true;

            this.service
                .findAllOrigens()
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por origens.`
                        );
                        this.origemSelect = [];
                    } else {
                        return r.content.map((v, i) => {
                            return { id: i+1, label: v };
                        });
                    }
                })
                .then(origens => {
                    let elements = [{ id: 0, label: 'todos' }].concat(origens);
                    this.origemSelect = elements;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por origens.`, e);
                    this.origemSelect = [];
                })
                .finally(() => {
                    this.origemLoading = false;
                });
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let params = [
                this.queryFilter != "" ? this.queryFilter : ".*",
                this.origemSelected.label,
            ];
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.motivos = value;
                    this.isEmpty = this.motivos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os dados.");
                })
                .finally((_) => {
                    this.loadOrigem();
                    this.isLoading = false;
                    this.cleanHide = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idmotivo,
                    codigo: m.idmotivoerp,
                    motivo: m.descricao,
                    origem: m.origem,
                    cor: m.cor,
                    icone: m.icone.toLowerCase(),
                    situacao: m.situacao,
                    excluir: "excluir",
                    inicio: m.inicio
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.motivo }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacaoRegistro(),
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        onOrigemChanged(val) {
            this.origemSelected = val
                ? this.origemSelect.filter((v) => v.id == val.id)[0]
                : this.origemSelect[0];
            this.carregarDados();
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-motivo"
                    : "msg-erro-ao-reativar-motivo";

            let tempmotivo = {
                idmotivo: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
                inicio: this.delete.inicio,
                origem: this.delete.origem
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempmotivo)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-agro-motivo"
                                : "msg-sucesso-ao-desativar-agro-motivo";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage("error", "Erro ao atualizar status.");
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    if (e.body.status == 409) {
                        this.$root.showMessage('alert', e.body.message);
                    } else {
                        this.$root.showMessage("error", tempFailure);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        buildIcon(icon) {
            return `<i class="fa-lg ${icon}"></i>`;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>